/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const AngleLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={8}
    height={14}
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m2.828 7 4.95-4.95L6.364.636 0 7l6.364 6.364 1.414-1.414L2.828 7Z"
      fill="currentColor"
    />
  </svg>
);

export default AngleLeft;
